import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { footerContent } from "../mock";
import { ChevronUp } from "lucide-react";

const Footer = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="relative bg-[#4A4A4A] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col items-center gap-1">
        <p className="text-[15px] tracking-wide">{footerContent.text}</p>
        <Link
          to="/admin"
          className="text-[13px] text-white/60 hover:text-white transition-colors underline-offset-2 hover:underline"
        >
          Admin
        </Link>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Torna in alto"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-md bg-[#E23028] text-white flex items-center justify-center shadow-lg transition-all duration-300 hover:-translate-y-1 ${
          show ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <ChevronUp size={22} />
      </button>
    </footer>
  );
};

export default Footer;
